module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-08.ec4fcb3e.png";